/* eslint-disable import/prefer-default-export */
export const processBatchDataFromAPI = (batchDetails) => ({
  ...(batchDetails || {}),
  testSeries: batchDetails?.testSeriesCount,
  authors: (batchDetails?.authors || []).map((author) => ({
    ...author,
    liveMinutes: author.liveMinutes ? Math.round(author.liveMinutes / 60) : 0,
    totalWatchMins: author.totalWatchTime
      ? Math.round(author.totalWatchTime / 60)
      : 0,
    name: `${author.firstName || ''} ${author.lastName || ''}`
  }))
});
